import { WFSCollector } from "./WFSCollector";
import { wfsEndpoints } from "./WFSCollectorEndpoints";

export class WFSUtilsCollector {

   static async bfeUnderPoint([lon, lat]: [number, number]) {
      let result = await WFSCollector.getFeaturePoint("Matriklen2", "Jordstykke_Gaeldende", [lon, lat]);
      return {
         sfeNr: result.features[0]?.properties?.samletFastEjendomLokalId,
         ejerl: result.features[0]?.properties?.ejerlavskode,
         matnr: result.features[0]?.properties?.matrikelnummer
      };
   }

   static async jordstykkerFraSFE<T extends string | number>(id: T | T[]): Promise<GeoJSON.FeatureCollection> {
      let ids = Array.isArray(id) ? id : [id];
      let jordstykker = await WFSCollector.getFeatureQuery("Matriklen2", "Jordstykke_Gaeldende",
         `samletFastEjendomLokalId in (${ids.map((a) => `'${a}'`).join(",")})` // eg. ('351352','351234','412454')
      );
      return jordstykker
   }

   static async PlanData(geom: unknown, planType: keyof (typeof wfsEndpoints["Plandata.dk"]["featureTypes"])): Promise<GeoJSON.FeatureCollection> {
      let result = await WFSCollector.getFeatureIntersect("Plandata.dk", planType, geom as any).catch(err => {
         console.error("Error fetching plan data:", err);
      })
      console.log("Received plan data result:", result);
      return result;
   }
}